import { Component } from '@angular/core';

@Component({
    selector: 'app-not-found-page',
    templateUrl: './not-found-page.component.html',
    standalone: false
})
export class NotFoundPageComponent {

}
